<template>
  <basic-dialog :show="show" @close="$emit('close')" max-width="800">
    <template v-slot:title>{{ title }}</template>
    <v-row>
      <v-col>
        <v-text-field label="Name" v-model="name" :outlined="outlinedInputs" />
      </v-col>
    </v-row>
    <v-row>
      <v-col class="py-0">
        <v-checkbox label="Pickup" v-model="isPickup" />
      </v-col>
      <v-col class="py-0">
        <v-checkbox label="Dropoff" v-model="isDropoff" />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-textarea
          label="Zone/Address"
          v-model="address"
          :outlined="outlinedInputs"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-text-field
          label="Coordinates (lat, lon)"
          v-model="coordinates"
          :outlined="outlinedInputs"
          append-icon="mdi-map-marker"
          @click:append="showCoordinatesMap = true"
        ></v-text-field>
      </v-col>
    </v-row>
    <coordinates-dialog
      :show="showCoordinatesMap"
      @close="showCoordinatesMap = false"
      @save="showCoordinatesMap = false"
      :address="address"
      v-model="coordinates"
    ></coordinates-dialog>
    <template v-slot:actions>
      <v-btn color="primary" @click="onSave" :disabled="!isValid">Save</v-btn>
    </template>
    <div v-if="debug">
      <code
        >{{ value }}
        {{ value.isPickup && value.isPickup.toString() == true }} -{{
          value.isPickup.toString()
        }}-</code
      >
    </div>
  </basic-dialog>
</template>

<script>
import BasicDialog from "../../shared/BasicDialog.vue";
import CoordinatesDialog from "../../shared/CoordinatesDialog.vue";
export default {
  name: "pickup-edit-dialog",
  props: {
    value: {
      type: Object,
      default: () => null,
    },
    show: {
      type: Boolean,
      default: () => false,
    },
  },
  components: { BasicDialog, CoordinatesDialog },

  data() {
    return {
      debug: false,
      name: this.value ? this.value.name : "New Pickup/Dropoff",
      zone: this.value ? this.value.zone : "",
      isPickup: this.value ? this.value.isPickup : false,
      isDropoff: this.value ? this.value.isDropoff : false,
      address: this.value ? this.value.address : "",
      coordinates: this.value ? this.value.coordinates : "",
      showCoordinatesMap: false,
    };
  },

  computed: {
    title() {
      return this.value && this.value.id ? this.name : "New Pickup/DropOff";
    },
    isValid() {
      return this.name && this.name != "" && (this.isDropoff || this.isPickup);
    },
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
  },

  watch: {
    value(newVal) {
      this.name = newVal.name;
      this.zone = newVal.zone;
      this.isPickup = newVal.isPickup && newVal.isPickup.toString() == "true";
      this.isDropoff =
        newVal.isDropoff && newVal.isDropoff.toString() == "true";
      this.address = newVal.address;
      this.coordinates = newVal.coordinates;
    },
  },

  methods: {
    onSave() {
      this.$emit("input", {
        id: this.value && this.value.id ? this.value.id : undefined,
        name: this.name,
        zone: this.zone,
        isPickup: this.isPickup,
        isDropoff: this.isDropoff,
        address: this.address,
        coordinates: this.coordinates,
      });
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/admin/destinations/PickupEditDialog.vue